import type { OnDestroy } from '@angular/core';
import { Injectable, signal } from '@angular/core';

@Injectable()
export class ElapsedTimeService implements OnDestroy {
  private intervalId?: ReturnType<typeof setInterval>;
  readonly now = signal(Date.now());

  start(): void {
    this.intervalId ??= setInterval(() => this.now.set(Date.now()), 1000);
  }

  stop(): void {
    clearInterval(this.intervalId);
    this.intervalId = undefined;
  }

  ngOnDestroy(): void {
    this.stop();
  }

  /** Folyamatos eltelt idő megjelenítéshez el kell indítani a start()-al a számlálót. */
  elapsed(isoString: string, toIso: string | null = null): string {
    const start = new Date(isoString).getTime();
    const toDate = toIso === null ? this.now() : new Date(toIso).getTime();
    if (Number.isNaN(start) || Number.isNaN(toDate)) return '--:--:--';
    const diff = Math.max(0, toDate - start);
    const s = Math.floor(diff / 1000) % 60;
    const m = Math.floor(diff / 60000) % 60;
    const h = Math.floor(diff / 3600000);
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
}
